import React, { useState, useEffect } from 'react';
import { User } from '../types';
import NavigationSidebar from '../components/NavigationSidebar';

interface LegalScreenProps {
    currentUser: User;
    title: string;
    content: React.ReactNode;
    onBack: () => void;
    currentPage: 'privacy-security' | 'security-policy' | 'community-guidelines' | 'terms-of-service' | 'about';
    onGoToMenu?: () => void;
    onGoToHelp?: () => void;
    onGoToContact?: () => void;
    onGoToPrivacySecurity?: () => void;
    onGoToSecurityPolicy?: () => void;
    onGoToCommunityGuidelines?: () => void;
    onGoToTermsOfService?: () => void;
    onGoToAbout?: () => void;
}

const LegalScreen: React.FC<LegalScreenProps> = ({ 
    currentUser, 
    title, 
    content, 
    onBack,
    currentPage,
    onGoToMenu,
    onGoToHelp,
    onGoToContact,
    onGoToPrivacySecurity,
    onGoToSecurityPolicy,
    onGoToCommunityGuidelines,
    onGoToTermsOfService,
    onGoToAbout,
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
        <div
            style={{
                height: '100vh',
                background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #dcdcdc 100%)',
                display: 'flex',
                flexDirection: 'column',
                fontFamily: 'Arial, sans-serif',
                color: '#333',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            {/* サイドバー（スマホのみ） */}
            {isMobile && (
                <NavigationSidebar
                    isOpen={sidebarOpen}
                    onClose={() => setSidebarOpen(!sidebarOpen)}
                    currentPage={currentPage}
                    onGoToMenu={onGoToMenu || onBack}
                    onGoToHelp={onGoToHelp || onBack}
                    onGoToPrivacySecurity={onGoToPrivacySecurity || onBack}
                    onGoToSecurityPolicy={onGoToSecurityPolicy || onBack}
                    onGoToCommunityGuidelines={onGoToCommunityGuidelines || onBack}
                    onGoToTermsOfService={onGoToTermsOfService || onBack}
                    onGoToAbout={onGoToAbout || onBack}
                />
            )}

            {/* ヘッダー */}
            <div
                style={{
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    flexShrink: 0,
                    background: 'rgba(255, 255, 255, 0.9)',
                }}
            >
                {isMobile ? (
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '5px',
                            color: '#333'
                        }}
                    >
                        ☰
                    </button>
                ) : (
                    <h1 style={{ margin: 0, fontSize: '24px' }}>{title}</h1>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {isMobile && (
                        <button
                            onClick={onGoToMenu || onBack}
                            style={{
                                background: '#667eea',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            メニューに戻る
                        </button>
                    )}
                    {!isMobile && (
                        <button
                            onClick={onBack}
                            style={{
                                background: '#667eea',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            ← 戻る
                        </button>
                    )}
                </div>
            </div>

            {/* メインコンテンツ */}
            <div
                style={{
                    flex: 1,
                    overflow: 'auto',
                    padding: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    minHeight: 0,
                }}
            >
                <div
                    style={{
                        maxWidth: '800px',
                        width: '100%',
                        background: 'rgba(255, 255, 255, 0.9)',
                        padding: '30px',
                        borderRadius: '20px',
                        backdropFilter: 'blur(10px)',
                        lineHeight: '1.8',
                        fontSize: '14px',
                    }}
                >
                    {content}
                </div>
            </div>

            {/* フッター */}
            <div
                style={{
                    padding: '10px 20px',
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#666',
                    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                    flexShrink: 0,
                }}
            >
                Voitter © 2025
            </div>
        </div>
    );
};

export default LegalScreen;
